import { BaseModel } from 'paliari-js-utils'
import Socio from './Socio'

const attrs = () => ({
  id: null,
  situacao: {},
  cadastro_imobiliario: {},
  situacao_id: null,
  cgcm_id: null,
  contribuinte_id: null,
  endereco_formatado: '',
  endereco_id: null,
  excluido: false,
  inspetoria: {},
  inspetoria_id: null,
  lote: '',
  numero: null,
  pessoa: {},
  pessoa_id: null,
  pessoas: [],
  quadra: null,
  situacao: null,
  tipo: '',
  updated_at: null,
  zona: null,
  socios: (socios = []) => socios.map(s => new Socio(s)),
})

export default class Cadastro extends BaseModel {
  constructor(obj) {
    super(attrs(), obj)
  }
}
